import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// gen_ext_imports


import { HttpInterceptRequestService } from './http-interceptors';
import { MaterialModule } from './_material/_material.module';
// gen_imports


/**
 * Modulo donde se puede realizar instanciación global de clases
 */
@NgModule({
  imports: [CommonModule, MaterialModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptRequestService, multi: true },
// gen_providers

  ],
  declarations: []
})
export class CoreModule {}
